import { useMemo } from 'react';
import { appendClassName, makeBEM } from '../../../utils';

var classGeneratorBasedOnComponent = function classGeneratorBasedOnComponent(_ref) {
  var component = _ref.component,
      classPrefix = _ref.classPrefix,
      disabled = _ref.disabled;
  var baseClassNames = makeBEM(classPrefix, component);
  var stateClassNames = [];

  if (disabled) {
    stateClassNames.push(makeBEM(classPrefix, component, 'disabled'));
  }

  return "".concat(baseClassNames, " ").concat(stateClassNames.join(' ')).trim();
};

export var useOptionListClassName = function useOptionListClassName(classPrefix, className, disabled) {
  return useMemo(function () {
    return {
      Root: appendClassName(classGeneratorBasedOnComponent({
        component: 'Root',
        classPrefix: classPrefix,
        disabled: disabled
      }), className),
      Item: classGeneratorBasedOnComponent({
        component: 'Item',
        classPrefix: classPrefix,
        disabled: disabled
      }),
      SelectAllItem: classGeneratorBasedOnComponent({
        component: 'SelectAllItem',
        classPrefix: classPrefix,
        disabled: disabled
      }),
      BeforeSectionContainer: classGeneratorBasedOnComponent({
        component: 'BeforeSectionContainer',
        classPrefix: classPrefix,
        disabled: disabled
      }),
      SearchContainer: classGeneratorBasedOnComponent({
        component: 'SearchContainer',
        classPrefix: classPrefix,
        disabled: disabled
      }),
      Search: classGeneratorBasedOnComponent({
        component: 'Search',
        classPrefix: classPrefix,
        disabled: disabled
      })
    };
  }, [classPrefix, className, disabled]);
};